// @ts-check
import { formatQueryRange } from '../utils/common';
import { removeFalseyParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class AgendaJobsAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'agenda-jobs' });
  }

  /**
   * @param {{ paymentScheduleId: string, type: 'future' | 'past' }} filters
   * @param {number} [pageNumber]
   * @param {number} [pageSize]
   * @param {string} [sort]
   */
  fetchCronJobs = async ({ paymentScheduleId, type }, pageNumber, pageSize, sort) => {
    const range = formatQueryRange(pageNumber, pageSize);
    const params = removeFalseyParams({ paymentScheduleId, type, range, sort });

    const response = await handleApiCalls('get', this.baseUrl, {
      params: { ...params, range },
    });

    return response.data;
  };
}

export default AgendaJobsAPI;
